import { withAuthenticationRequired } from '@auth0/auth0-react'
import { NotFound } from 'modules/NotFound'
import { Route, Routes } from 'react-router'
import { ModalPage } from '../../components/layout'
import { ReservationCancelSuccess, ReservationConvertSuccess, ReservationNew, ReservationSuccess } from '../../components/Reservation'
import { ReservationFormData } from '../../components/Reservation/New/Form/constants'
import { ClickTrackingProvider, FormAnalyticsProvider, IsReservationFlowProvider, SessionDurationProvider } from '../../hooks'
import { ReservationProvider } from '../../hooks/useReservation'

const ReservationRoutes = () => {
  return (
    <ModalPage>
      <IsReservationFlowProvider>
        <Routes>
          <Route
            element={
              <SessionDurationProvider>
                <ClickTrackingProvider>
                  <FormAnalyticsProvider<ReservationFormData>>
                    <ReservationNew />
                  </FormAnalyticsProvider>
                </ClickTrackingProvider>
              </SessionDurationProvider>
            }
            path="/"
          />
          <Route
            element={
              <ReservationProvider>
                <ReservationSuccess />
              </ReservationProvider>
            }
            path=":reservationId/success"
          />
          <Route
            element={
              <ReservationProvider>
                <ReservationCancelSuccess />
              </ReservationProvider>
            }
            path=":reservationId/cancel/success"
          />
          <Route
            element={
              <ReservationProvider>
                <ReservationConvertSuccess />
              </ReservationProvider>
            }
            path=":reservationId/convert/success"
          />
          <Route element={<NotFound />} path="*" />
        </Routes>
      </IsReservationFlowProvider>
    </ModalPage>
  )
}

const Reservation = withAuthenticationRequired(ReservationRoutes)

export { Reservation }
